<template>
  <div v-if="message || showIfEmpty">
    <div class="text-h6 font-weight-black mt-3 text-c-green">
      {{ title }} :
    </div>
    <div class="case-info-text mt-5">
      <span v-if="!message">
        {{ noDataText }}
      </span>
      {{ message }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'NajItemDescription',
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: false,
      default: null,
    },
    noDataMessage: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    noDataText() {
      return this.noDataMessage || this.local.common.noData;
    },
    showIfEmpty() {
      return !!this.noDataMessage;
    },
  },
};
</script>

<style scoped >
.case-info-text {
  white-space: break-spaces;
  font-size: 16px;
  color: #748aa1;
  font-weight: 400;
  border: 2px solid rgb(221, 221, 221);
  border-radius: 6px;
  background: #fdfdfb 0% 0% no-repeat padding-box;
  padding: 35px 17px 25px 50px;
  overflow-y: auto;
  max-height: 200px;
}

    .text-c-green {
        color: var(--app-primary-color);
    }
</style>